import api from '@/sui/api/sheet'
import delay from '@/sui/api/delay'
import convert from '@/sui/data/sheets/convert'
import modules from '@/sui/data/modules'
import ice from '@/sui/tools/ice'

const state = {
  all: {
    bactADI: [],
    reaBactADI: [],
    reaInfADI: [],
    neoInfADI: [],
    diaInfADI: [],
    expADI: [],
    observa4: [],
    spy4: [],
    badiCause: []
  },
  available: {
    bactADI: false,
    reaBactADI: false,
    reaInfADI: false,
    neoInfADI: false,
    diaInfADI: false,
    expADI: false,
    observa4: false,
    spy4: false,
    badiCause: false
  },
  full: {
    bactADI: [],
    reaBactADI: [],
    reaInfADI: [],
    neoInfADI: [],
    diaInfADI: [],
    expADI: [],
    observa4: [],
    spy4: [],
    badiCause: []
  },
  fullAvailable: {
    bactADI: false,
    reaBactADI: false,
    reaInfADI: false,
    neoInfADI: false,
    diaInfADI: false,
    expADI: false,
    observa4: false,
    spy4: false,
    badiCause: false
  },
  edit: null
}

const getters = {
  edit: state => {
    if (state.edit == null) {
      return null
    }

    return convert.serverToClient(state.edit)
  },

  filter: (state) => (status) => {
    const result = {}
    for (let i in state.all) {
      result[i] = state.all[i].filter(e => e.status === status)
    }
    return result
  }
}

const actions = {
  loadAll ({ commit }, data) {
    commit('reset')

    const types = data.availableSheetModules
    const list = modules.get(data.year)
    const promises = []
    for (let i in types) {
      const t = types[i]
      if (list[t].sheets.edit != null) {
        promises.push(api.all({ t: t, s: data.id, y: data.year }))
      } else {
        promises.push(delay(0)({ data: { v: [] } }))
      }
    }

    return Promise.all(promises).then((values) => {
      const operations = []
      for (let i in values) {
        const { data } = values[i]
        if (data.err != null || data.v == null) {
          throw new Error(`Could not get all sheets: ${data.err}`)
        } else {
          operations.push({ type: types[i], values: data.v })
        }
      }
      commit('setSheets', operations)
      return values
    })
  },

  full ({ commit }, data) {
    commit('resetFull', data.t)
    return api.full(data).then((response) => {
      const { v, err } = response.data
      if (err == null && v != null) {
        v.forEach(s => { s.t = data.t })
        commit('setFull', { full: v, type: data.t })
      } else {
        throw new Error(`Could not get sheet: ${err}`)
      }
      return response
    })
  },

  load ({ commit }, data) {
    commit('resetList', data.t)
    commit('resetFull', data.t)

    return api.all(data).then((response) => {
      if (response.data.err == null) {
        const operations = [{ type: data.t, values: response.data.v }]
        commit('setSheets', operations)
      }
      return response
    })
  },

  fromPeriod (_, data) {
    return api.fromPeriod(data).then((response) => {
      const { v, err } = response.data
      if (err == null && v != null) {
        v.forEach(s => { s.t = data.type })
      }
      return response
    })
  },

  add ({ dispatch }, data) {
    return api.add(data).then((response) => {
      return response
    })
  },

  update ({ dispatch }, data) {
    return api.update(data).then((response) => {
      return response
    })
  },

  edit ({ commit }, data) {
    const type = data.t
    const year = data.y
    return api.get(data).then((response) => {
      const { v, err } = response.data
      if (err == null && v != null) {
        v.t = type
        v.y = year
        commit('setEdit', v)
      } else {
        throw new Error(`Could not get sheet: ${err}`)
      }

      return response
    })
  },

  remove ({ dispatch }, data) {
    return api.remove(data).then((response) => {
      if (response.data.err == null) {
        dispatch('load', { s: data.s, t: data.t, y: data.y })
      }
      return response
    })
  },

  statuses ({ dispatch }, data) {
    return api.statuses(data)
  },

  fromVersion (_, data) {
    return api.fromVersion(data).then((response) => {
      const { v, err } = response.data
      if (err == null && v != null) {
        v.forEach(s => { s.t = data.type })
      }
      return response
    })
  }
}

const mutations = {
  reset (state) {
    state.all.bactADI = []
    state.all.reaBactADI = []
    state.all.reaInfADI = []
    state.all.diaInfADI = []
    state.all.neoInfADI = []
    state.available.bactADI = false
    state.available.reaBactADI = false
    state.available.reaInfADI = false
    state.available.diaInfADI = false
    state.available.neoInfADI = false
    state.full.bactADI = []
    state.full.reaBactADI = []
    state.full.reaInfADI = []
    state.full.diaInfADI = []
    state.full.neoInfADI = []
    state.fullAvailable.bactADI = false
    state.fullAvailable.reaBactADI = false
    state.fullAvailable.reaInfADI = false
    state.fullAvailable.diaInfADI = false
    state.fullAvailable.neoInfADI = false

    state.edit = null
  },

  resetList (state, type) {
    state.all[type] = []
    state.available[type] = false
  },

  setSheets (state, values) {
    for (let i in values) {
      const value = values[i]
      state.all[value.type] = ice.freeze(value.values)
      state.available[value.type] = true
    }
  },

  setEdit (state, edit) {
    state.edit = edit
  },

  resetFull (state, type) {
    state.full[type] = []
    state.fullAvailable[type] = false
  },

  setFull (state, data) {
    state.full[data.type] = ice.freeze(data.full)
    state.fullAvailable[data.type] = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
